import { useState, useEffect } from 'react'
import useApi, { request } from 'hooks/useApi'

export default function useOpenAi() {
  const [openAiState, setState] = useState({
    isLoading: false,
    isFlagged: false,
    containsProfanity: false,
    isSuggesting: false,
  });
  
  const voiceSuggest = async (script) => {
    setState({
      isLoading: true,
    });

    const result = await request('/rest/v2/openai/script-to-talent-suggestion', {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          script,
        }),
      },
    });

    setState({
      isLoading: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data'][0];
  }

  const moderateContent = async (script) => {
    setState({
      isLoading: true,
      isFlagged: false,
      containsProfanity: false,
    });

    const result = await request('/rest/v2/openai/moderations', {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          script,
        }),
      },
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    setState({
      isLoading: false,
      isFlagged: result['data']['flagged'],
      containsProfanity: result['data']['containsProfanity'],
    });

    return {
      isFlagged: result['data']['flagged'],
      containsProfanity: result['data']['containsProfanity'],
    };
  }

  const suggestVoiceOverScript = async (script) => {
    setState({
      isSuggesting: true,
    });

    const result = await request('/rest/v2/openai/suggest-voice-over-script', {
      fetchOptions: {
        method: 'POST'
      },
    });

    setState({
      isSuggesting: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data'][0];
  }

  return [openAiState, voiceSuggest, moderateContent, suggestVoiceOverScript]
}
